import { render, staticRenderFns } from "./IconFrance.vue?vue&type=template&id=fc570918&"
import script from "./IconFrance.vue?vue&type=script&lang=ts&"
export * from "./IconFrance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports